export default __webpack_public_path__ + "5367a6fc7bf5b0970c7852d049f9cf65.svg";